import React from "react";
import "./HomeBanner.scss"
import Avatar from "@mui/material/Avatar";
import { useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import { get_lang } from "../../helper/getLang";
import Navbar from "../Navbar/Navbar";

const HomeBanner = (props:any) => {
  const {corner = true} = props
  const appState = useSelector((state: RootState) => state.appReducer);
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { storeInfo } = apiState;
  // console.log("storeInfo",storeInfo)
  const {  bookingInfo } = storeInfo || {}; 
  return (
    <React.Fragment>
    <Navbar showBackBtn={false}/>
      {storeInfo ? <div
        className={`storeBanner ${corner ? `borderClass`: `borderNon`}`}
        style={{
          background: `linear-gradient(336deg, rgba(0, 0, 0, 0.67) 0%, rgba(0, 0, 0, 0.19) 100%), 
                        url(${true ? bookingInfo?.cover : `./Rectangle_16965.png`
            }) center center / cover no-repeat`,
        }}
      >
        <div
          className={` ${appState?.langValue === "ar" ? `contentArabic` : `content`}`}
        >
          <div   className={`mx-4 d-flex align-items-center ${appState?.langValue === "ar" ? `justify-content-start direction-rtl` : `justify-content-start`}`}
          >
            <Avatar variant="rounded" src={bookingInfo?.logo}></Avatar>

            <h5 className="mb-0 mx-2 familysora700">
              {get_lang(storeInfo?.bookingInfo?.title, appState?.langValue)}
            </h5>
          </div>
          <h3 
            className={`mt-4 mx-4 familysora600 ${appState?.langValue === "ar" ? `text-right` : `text-left`}`}
          >
            {" "}
            {get_lang(storeInfo?.bookingInfo?.description, appState?.langValue)}
          </h3>
        </div>
      </div> : <React.Fragment></React.Fragment>}</React.Fragment>
  );
};

export default HomeBanner;
